import * as React from 'react';
import { stringWithLineBreak } from 'sos-common/js/utils/helpers';

const NO_VALUE = 'Inget värde angivet';

/**
 * Traverses the form inputs and adds a printer friendly section for each element.
 * The created sections are only visible in print mode.
 */
export class Textualizer extends React.PureComponent {
  componentDidMount() {
    let standardInputs = document.querySelectorAll('.FormTextbox__Input');

    [].forEach.call(standardInputs, (element) => {
      let input = element as HTMLInputElement;
      let value = input.value ? stringWithLineBreak(input.value) : NO_VALUE;
      input.insertAdjacentHTML(
        'beforebegin',
        `<div data-master="${input.id}" class="only-print hide-sibling-in-print">${value}</div>`
      );

      input.addEventListener('change', (e) => {
        let textualizeDiv = document.querySelector(`div[data-master="${input.id}"]`);
        textualizeDiv.innerHTML = input.value ? stringWithLineBreak(input.value) : NO_VALUE;
      });
    });
  }

  public render() {
    return null;
  }
}
